import isDomUsable from '@fenderdigital/utils/dom';
import { Lesson } from '@fenderdigital/api-definitions/play';

/**
 * Constructs the email body for the feedback button in the LessonNav
 * @param {Lesson} currentLesson
 * @param {string} userID
 * @param {boolean} isMobileOrTablet
 * @returns {string}
 */
const constructFeedbackMailToBody = (
  currentLesson: Lesson,
  userID: string,
  isMobileOrTablet: boolean,
): string => {
  const mailToDevice = isMobileOrTablet ? 'MOBILEWEB' : 'WEB';
  const mailToDeviceDetails = isDomUsable() && window.navigator.userAgent;
  const mailToUrlArr: string[] = [];
  mailToUrlArr.push(`Provide your feedback on ${currentLesson?.title}:`);
  mailToUrlArr.push('\n\n\n------\n');
  mailToUrlArr.push(`Lesson ID: ${currentLesson?.id}\n`);
  mailToUrlArr.push(`Lesson Title: ${currentLesson?.title}\n`);
  mailToUrlArr.push(`Lesson Activity-Type: ${currentLesson?.['activity-type']}\n`);
  mailToUrlArr.push(`Lesson Instrument: ${currentLesson?.instrument}\n`);
  mailToUrlArr.push(`Lesson Level: ${currentLesson?.instrument}\n`);
  mailToUrlArr.push(`Lesson Slug: ${currentLesson?.slug}\n`);
  mailToUrlArr.push(`Lesson Type: ${currentLesson?.type}\n`);
  mailToUrlArr.push(`FC ID: ${userID}\n`);
  mailToUrlArr.push(`Platform : ${mailToDevice}\n`);
  mailToUrlArr.push(`Platform Details: ${mailToDeviceDetails}\n`);

  return encodeURIComponent(mailToUrlArr.join(''));
};

export default constructFeedbackMailToBody;
